import { all, fork } from "redux-saga/effects";
import { watchStylists } from "./stylistSaga";
import { watchServices } from "./serviceSaga";
import bookingSaga from "./bookingSaga";
import salonSaga from "./salonSaga";

// Root saga - combines all other sagas
export default function* rootSaga() {
  yield all([
    fork(watchStylists),
    fork(watchServices),
    fork(bookingSaga),
    fork(salonSaga),
  ]);
}
